import { render, staticRenderFns } from "./package-selector.vue?vue&type=template&id=f5dfd622"
import script from "./package-selector.vue?vue&type=script&lang=js"
export * from "./package-selector.vue?vue&type=script&lang=js"
import style0 from "./package-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports